import { render, staticRenderFns } from "./PaymentsInfo.vue?vue&type=template&id=386c4af6&scoped=true&"
import script from "./PaymentsInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentsInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsInfo.vue?vue&type=style&index=0&id=386c4af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386c4af6",
  null
  
)

export default component.exports